import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toQuestionsView } from '../../utils/routes';
import QuizProgressOverall from '../Crosspage/QuizProgressOverall';
import { maxQuizze } from '../../config';

export default function SubtopicTile(props) {

    const navigate = useNavigate();

    const goToQuestions = () => {
        navigate(toQuestionsView(props.quizpartId, props.id))
    }

    const buttonColor = !props.timesFinished ? "secondary" : "primary" 
    const webkitAnimation = !props.timesFinished ? "coloring 9s ease-out 0s infinite": ""

    return(
            <Box sx={{display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", mb: 2,
                width: "100%"
            }}>
                <Button sx={{width: "100%", animation: webkitAnimation}} variant='contained' onClick={goToQuestions} color={buttonColor}
                >{props.name}</Button>
                <QuizProgressOverall max={maxQuizze} n_finished={props.timesFinished}/>
            </Box>

    )
}